import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import AuthLayout from '../../components/layout/AuthLayout.jsx';
import { useImportContactsMutation } from '../../api/contact.js';
import { CONTACT_IMPORT_SCHEMA } from '../../utils/contact.js';
import { useErrors } from '../../hooks/useErrors.js';
import BaseButton from '../../components/form/BaseButton.jsx';
import BaseUpload from '../../components/form/BaseUpload.jsx';

const ImportContacts = () => {
    const [importContacts, { isLoading, error }] = useImportContactsMutation();
    const navigate = useNavigate();

    const { handleSubmit, getValues, formState, control, clearErrors, reset, setValue, watch } = useForm({
        resolver: yupResolver(CONTACT_IMPORT_SCHEMA),
        defaultValues: {
            file: []
        },
        reValidateMode: 'onSubmit'
    });

    const { errors } = useErrors(error?.message, formState);
    const currentFile = watch('file');

    const sendImportFile = async (requestData) => {
        const fileData = { file: requestData.file[0] };

        await importContacts(fileData).then((apiResponse) => {
            if (apiResponse.data?.success) {
                navigate('/contacts/list');
            }
        });
    };

    const onFileUpload = (acceptedFile) => {
        setValue('file', acceptedFile);
    };

    const onRemoveNewUploadedFile = (index) => {
        setValue(
            'file',
            currentFile.filter((_, i) => i !== index)
        );
    };

    const formValues = getValues();

    return (
        <AuthLayout title={'Import Contacts'}>
            <div className='max-w-3xl w-full mx-auto px-8'>
                <div className='mt-8 text-theme1-title2 font-bold text-xl'>Import vcf file</div>
                <div className='mb-10'>
                    <BaseUpload
                        accept={['vcf']}
                        newUploadedFiles={currentFile}
                        onFilesUpload={onFileUpload}
                        onRemoveNewUploadedFile={onRemoveNewUploadedFile}
                        reset={reset}
                        canDelete={false}
                        errors={errors.file}
                        isLoading={isLoading}
                    />
                </div>
            </div>

            <div className='max-w-3xl w-full mx-auto px-8'>
                <div className='mb-6'>
                    <div className='grid grid-cols-2 gap-4'>
                        <BaseButton
                            id='btn-submit'
                            className='btn-primary-outline'
                            onClick={handleSubmit(sendImportFile)}
                            isLoading={isLoading}
                            textValue={isLoading ? 'Importing...' : 'Import'}
                            disabled={!formValues.file || isLoading}
                        />

                        <BaseButton
                            id='btn-cancel'
                            className='btn-primary-outline'
                            onClick={() => navigate('/')}
                            textValue='Cancel'
                        />
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
};

export default ImportContacts;
